const initialState = {
  loading: false,
  data: [],
  error: null,
};

const teamsReducer = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case "TEAMS_PENDING":
      return {
        ...state,
        loading: true,
        error: null,
      };
    case "TEAMS_SUCCESS":
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      };
    case "TEAMS_ERROR":
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default teamsReducer;
